import { writable } from 'svelte/store/index.mjs';

let minMinPrice = 0;
let maxMaxPrice = 100;

export const categoryMinMinPrice = writable(minMinPrice); // The Minimum Min Value
export const categoryMaxMaxPrice = writable(maxMaxPrice); // The Maximum Max Value

export const categoryPrice = writable({
  minPrice: minMinPrice,
  maxPrice: maxMaxPrice,
});

/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */
export function updateCategoryPrice(min, max) {
  // eslint-disable-next-line
  categoryPrice.update(
    categoryPrices => (categoryPrices = { minPrice: min, maxPrice: max })
  );
}

export function updateMinPrice(min) {
  // eslint-disable-next-line
  categoryPrice.update(
    categoryPrices =>
      (categoryPrices = { minPrice: min, maxPrice: categoryPrices.maxPrice })
  );
}

export function updateMaxPrice(max) {
  // eslint-disable-next-line
  categoryPrice.update(
    categoryPrices =>
      (categoryPrices = { minPrice: categoryPrices.minPrice, maxPrice: max })
  );
}

export function resetPriceFilter() {
  // eslint-disable-next-line
  categoryPrice.update(
    categoryPrices =>
      (categoryPrices = {
        minPrice: minMinPrice,
        maxPrice: maxMaxPrice,
      })
  );
}

export function updateMinMinPrice(min) {
  minMinPrice = min;
  // eslint-disable-next-line
  categoryMinMinPrice.update(currentMinMinPrice => (currentMinMinPrice = min));
}

export function updateMaxMaxPrice(max) {
  maxMaxPrice = max;
  // eslint-disable-next-line
  categoryMaxMaxPrice.update(currentMaxMaxPrice => (currentMaxMaxPrice = max));
}
